import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BspiHeader, BspiFooter } from './bspi/HomeSections';
import '../theme-bspi.css';

// 404 — matches the v2 design language. Sets a proper document title and
// adds a `noindex` meta tag so search engines won't cache the not-found route.
// We can't send a real 404 HTTP status from a static CRA build; the Deploy
// step should map unknown paths → 404. This page carries the intent.
export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page not found | Black Star PI';
    // Override the base index.html <meta name="robots" content="index, follow">
    // rather than appending a second (conflicting) tag.
    const existing = document.querySelector('meta[name="robots"]');
    const previous = existing ? existing.getAttribute('content') : null;
    let created = null;
    if (existing) {
      existing.setAttribute('content', 'noindex,nofollow');
    } else {
      created = document.createElement('meta');
      created.name = 'robots';
      created.content = 'noindex,nofollow';
      document.head.appendChild(created);
    }
    // Signal to prerender tools (react-snap etc.) that this is a 404.
    // eslint-disable-next-line no-underscore-dangle
    if (typeof window !== 'undefined') { window.__PRERENDER_STATUS_CODE = 404; }
    return () => {
      if (created) { document.head.removeChild(created); }
      else if (existing && previous !== null) { existing.setAttribute('content', previous); }
    };
  }, []);

  return (
    <div className="bspi">
      <BspiHeader />
      <main>
        <section className="hero" style={{ padding: 0 }}>
          <div className="wrap" style={{ minHeight: '60vh' }}>
            <span className="eyebrow" style={{ marginTop: 40 }}>Error 404</span>
            <h1 data-testid="notfound-heading">
              We couldn't find <em>that page.</em>
            </h1>
            <p className="lead">
              The link may be old, or the page may have moved. Everything Black Star PI does starts on the homepage.
            </p>
            <div className="ctas">
              <Link to="/" className="btn btn-gold" data-testid="notfound-home-cta">
                Back to home →
              </Link>
              <Link to="/insights" className="btn btn-line" data-testid="notfound-insights-cta">
                Read our thinking
              </Link>
            </div>
          </div>
        </section>
      </main>
      <BspiFooter />
    </div>
  );
}
